export { clickBySelector } from './click-by-selector';
export { clickByText } from './click-by-text';
export { doubleClickBySelector } from './double-click-by-selector';
export { rightClickBySelector } from './right-click-by-selector';
export { dragFromTo } from './drag-from-to';
